module.exports = __webpack_public_path__ + "media/promo/velle/images/background_granola-2588fec32aaebc5cb0b8d3c6ab89a9f5.png";